<template>
  <a-layout class="group-manage">
    <a-layout-sider width="256" style="background: #fff;padding:16px 0 16px 16px">
      <div class="search" style="margin-bottom:8px">
        <a-input-search v-model="searchGroup" @search="getList(0)" placeholder="请输入分组名称" />
      </div>
      <div class="addGroup" style="margin-bottom:8px">
        <a-button type="primary" v-action:add @click="addGroup" block>新建分组</a-button>
      </div>
      <a-menu
        style="width:240px;border-right:0"
        mode="vertical"
        :selectedKeys="selectedKeys"
        @select="onSelect"
        @click="handleClick">
        <a-menu-item class="menuItem" v-for="(group, index) in groupList" :key="index">
          <a-tooltip placement="topLeft" :title="group.remark">
            {{ group.name }}
          </a-tooltip>
          <div class="icon-panel">
            <a-tooltip>
              <template slot="title">
                编辑
              </template>
              <a-icon type="edit" v-action:update @click="editGroup(group)" style="right:30px;margin-right:0px;" />
            </a-tooltip>
            <a-popconfirm placement="topRight" title="您确定要删除此分组吗?" @confirm="e => remove(group)">
              <a-tooltip>
                <template slot="title">
                  删除
                </template>
                <a-icon type="delete" v-action:delete style="margin-right:0px;" />
              </a-tooltip>
            </a-popconfirm>
          </div>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <list-model ref="listModel"></list-model>
      </div>
    </a-layout-content>
    <!-- 新增分组弹窗 -->
    <add-group-modal ref="addGroupModal" @updateList="updateList"> </add-group-modal>

  </a-layout>

</template>
<script>
import { getGroupList, deleteGroup } from '@/api/group'
import listModel from './modules/listModel'
import addGroupModal from './modules/addGroupModal'
export default {
  name: 'GroupList',
  components: {
    listModel,
    addGroupModal
  },
  data () {
    return {
      // 角色搜索关键字
      searchGroup: '',
      groupTotalList: [],
      // 分组id
      groupId: 0,
      // 分组名称
      groupName: '',
      selectedKeys: []
    }
  },
  computed: {
    groupList () {
      return this.groupTotalList.filter(item => {
        //  return item.name.indexOf(this.searchGroup.trim()) > -1
        return item.name
      })
    }
  },
  methods: {
    // 新增分组
    addGroup () {
      this.$refs.addGroupModal.setTitle('新增分组')
      this.$refs.addGroupModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.addGroupModal.open(true)
      // 接口调用成功后重新获取角色列表
    },
    // 编辑分组
    editGroup (group) {
      this.$refs.addGroupModal.setTitle('编辑分组')
      this.$refs.addGroupModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.addGroupModal.setModel(group)// 先设置类型，再打开
      this.$refs.addGroupModal.open(true)
    },
    // 刪除分組
    deleteGroup (group) {
      this.$confirm({
        title: '删除分组',
        content: `是否确认删除分组【${group.name}】？删除后该分组将不可恢复。`,
        onOk: (e) => this.handleDel(group, e),
        onCancel () {}
      })
    },
    // 删除分组接口调用
    handleDel (group, e) {
      return new Promise((resolve, reject) => {
        deleteGroup(group.id).then(res => {
          if (res.status === 0) {
            this.$message.success(res.info.message)
            this.updateList()
            e()
          } else {
            this.$message.error(res.info.message)
            e()
          }
        }).catch(() => {
          this.$message.error('err')
          e()
        })
      }).catch(() => console.log('Oops errors!'))
    },
    // 删除分组
    remove (group) {
      deleteGroup(group.id).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.getList(0)
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(() => {
        this.$message.error('error')
      })
    },
    // 刷新侧边栏数据
    updateList () {
      if (this.groupId == 0) {
        this.getList(0)
      } else {
        this.getList()
      }
    },
    onSelect ({ item, key, selectedKeys }) {
      this.selectedKeys = selectedKeys
    },
    // 点击侧边栏选中回调
    handleClick (e) {
      this.groupId = this.groupList[e.key].id
      this.groupName = this.groupList[e.key].name
      this.$store.commit('setGroupId', this.groupId)
      this.$store.commit('setGroupName', this.groupName)
      this.$refs.listModel.initTableData()
    },
    // 初始化分组数据
    getList (status) {
      // 调用接口
      const params = {
        status: 1,
        name: this.searchGroup.trim(),
        paging: false
      }
      getGroupList(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.groupTotalList = res.data
            this.getUserList(status)
          } else {
            this.groupTotalList = []
            this.getUserList(1)
          }
        }
      })
    },
    // 获取初始分组人员列表
    getUserList (status) {
      if (this.groupList.length > 0) {
        if (status === 0) {
          this.selectedKeys = [0]
          this.groupId = this.groupList[0].id ? this.groupList[0].id : 0
          this.groupName = this.groupList[0].name ? this.groupList[0].name : ''
          this.$store.commit('setGroupId', this.groupId)
          this.$store.commit('setGroupName', this.groupName)
          // 获取成功后调用获取右侧展示接口
          this.$refs.listModel.initTableData()
        } else if (status === 1) {
          // 最后一个删除后
          this.groupId = 0
          this.groupName = ''
          this.$store.commit('setGroupId', this.groupId)
          this.$store.commit('setGroupName', this.groupName)
          this.$refs.listModel.clearTableData()
        } else {
          // 获取成功后调用获取右侧展示接口
          console.log('this.groupId:', this.groupId)
          this.$refs.listModel.initTableData()
        }
      }
    }
  },
  mounted () {
    // 获取侧边栏数据
    this.getList(0)
    // this.getUserList();
  }
}
</script>

<style lang="less">
// .groupEdit{
//     display: none;
// }
// .menuItem:hover{
//     .groupEdit{
//         display: inline-block;
//     }
// }
// .ant-menu-item-selected{
//     .groupEdit{
//         display: inline-block;
//     }
// }
.ant-tooltip{
  z-index:1020;
}
.group-manage{
    .icon-panel {
        float: right;
        position: absolute;
        right: 0;
        top: 0;

        .anticon-edit,
        .anticon-delete {
            margin-left: 5px;
            color: #1890ff;
        }
    }
}

</style>
